export const mustBeDate = (value) => value instanceof Date;
export const mustBetrue = (value) => value === true;
